/* eslint-disable */
// GLOBAL getters
import i18n from '@/i18n';

export default {
  get_error_message: (state) => state.errorMessage,
  get_error: (state) => state.error,
  get_notification_bar: (state) => state.notification,
  get_notification_bar_message: (state) => {
    if (typeof state.notification.message === 'string') {
      return  i18n.t(state.notification.message);
    }
    if (typeof state.notification.message === 'object') {
      let notification = ''
      for (const [key, value] of Object.entries(state.notification.message)) {
        let field = key
        let message = value[Object.keys(value)[0]]

        if (notification !== '') {
          notification += '</br>'
        }

        notification += i18n.t(field) + ': ' + i18n.t(message)
      }

      return notification
    }
  },
  get_currency: (state) => state.currency,
  get_language: (state) => state.language,
  get_import_queue: (state) => state.importQueue,
  get_import_queue_ids: (state) => state.importQueueIds,
};
